import { IkeToken } from '@ikegps/core-api';
import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { CollectionDuplicateModal } from '../collection.duplicate.modal/collection.duplicate.modal';

export const CollectionDuplicateCtrl = {
	canDuplicate(): boolean {
		return (
			(Services.Token.has(IkeToken.FEATURE_COLLECTION_DUPLICATE) ||
				Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE)) &&
			Services.Token.has(IkeToken.TAG_JOB_UPDATE)
		);
	},

	showDuplicateModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionDuplicateModal(
			{
				title: T.COLLECTION_DUPLICATE_TITLE,
				confirm: T.OK,
				success: {
					key: T.COLLECTION_DUPLICATE_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		modal.open();
	},
};
